<template>
  <div class="home">
    <PageHero />
    <div class="container my-12">
      <SectionPromoMobileApp></SectionPromoMobileApp>
    </div>
    <SectionEducation />
    <SectionObesity />
    <SectionDownloads />
  </div>
</template>

<script>
import PageHero from "../components/PageHero.vue";
import SectionDownloads from "../components/SectionDownloads.vue";
import SectionEducation from "../components/SectionEducation.vue";
import SectionObesity from "../components/SectionObesity.vue";
import SectionPromoMobileApp from "../components/SectionPromoMobileApp.vue";

export default {
  components: {
    PageHero,
    SectionEducation,
    SectionDownloads,
    SectionObesity,
    SectionPromoMobileApp,
  },
};
</script>
